export default "__VITE_ASSET__CVdl4nH___"